/* global Swiper */

export default {
  init() {
    // Exit if Swiper isn't loaded
    if (typeof Swiper === 'undefined') return;

    // Initialize all swipers in case there are multiple on a page
    const swipers = document.querySelectorAll('.mySwiper');
    if (!swipers.length) return;

    swipers.forEach((el) => {
      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        grabCursor: true,
        speed: 600, // smooth transition
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/carouselCustomerStories.js